<template>
    <section id="team" class="section-padding">
        <div class="container">
            <div class="section-header text-center">
                <h2 class="section-title wow fadeInDown" data-wow-delay="0.3s">{{$t('menus.OurStaff')}}</h2>
                <div class="shape wow fadeInDown" data-wow-delay="0.3s"></div>
            </div>
            <div class="row">
                <h4 class="img wow fadeInDown" data-wow-delay="0.4s">
                    <img class="img-fluid" src="../assets/img/v2/services-dttcs-02.svg" alt="" >
                </h4>
                <p class=" wow fadeInDown" data-wow-delay="0.4s">{{$t('team.txt1')}}</p>
                <p class=" wow fadeInDown" data-wow-delay="0.4s">{{$t('team.txt2')}}</p>

            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "OurStaff"
    }
</script>

<style scoped>

</style>
